// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--n3XTp","background":"layout-module--background--35tv6"};